import { ErrorHandler, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { Logger } from './logger.service';

export class A7ResourcesCommonErrorHandler extends ErrorHandler {
  private isHandlingError = false;

  constructor(
    private logger: Logger,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    super();
  }

  handleError(error: any) {
    super.handleError(error);
    if (isPlatformBrowser(this.platformId) && !this.isHandlingError) {
      this.isHandlingError = true;
      try {
        this.logger.warn('client side error', error);
      } finally {
        this.isHandlingError = false;
      }
    }
  }
}
